import { useRef } from 'react'
import { Avatar, Button, Drawer, useDrawer } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { colorAvatarByName } from '@/common/utils/colorAvatarByName'
import { useManageApplicationAccountUser } from '../hooks/useManageApplicationAccountUser'
import { useSelectedUserApplicationAccountUserStore } from '../stores/useSelectedUserApplicationAccountUserStore'
import {
  CardApplicationAccountUser,
  CardApplicationAccountUserRef,
} from './CardApplicationAccountUser'

export function DrawerManageApplicationAccountUser() {
  const { t } = useTranslation(['sso', 'common'])
  const { userAccess } = useSelectedUserApplicationAccountUserStore()
  const drawerManageUserAccess = useDrawer(
    'drawer-manage-application-account-user',
  )
  const { userApplications } = useManageApplicationAccountUser()
  const formRefs = useRef<Record<string, CardApplicationAccountUserRef>>({})

  const handleCloseDrawer = () => {
    Object.values(formRefs.current).forEach((ref) => {
      ref?.resetForm()
    })
    drawerManageUserAccess.close()
  }

  return (
    <Drawer.Root id="drawer-manage-application-account-user">
      <Drawer.Header onClose={handleCloseDrawer}>
        <h1 className="text-lg text-brand-800 font-semibold">
          {t('sso:access.drawer_manage_user_access.header.title')}
        </h1>
      </Drawer.Header>

      <Drawer.Body>
        <h2 className="text-2xl font-semibold text-brand-700">
          {t('sso:access.drawer_manage_user_access.body.title')}
        </h2>

        <div className="flex items-center gap-2 border border-neutral-200 rounded-2xl py-4 px-5">
          <Avatar
            size="lg"
            type="solid"
            color={colorAvatarByName(
              userAccess?.UserPreference.displayName || '',
            )}
            name={userAccess?.UserPreference.displayName || ''}
            src={userAccess?.UserPreference.avatarUrl || ''}
          />

          <div>
            <p className="font-medium text-sm text-base-800">
              {userAccess?.UserPreference.displayName || ''}
            </p>
            <p className="text-sm font-light text-base-700">
              {userAccess?.email || ''}
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-brand-700">
          {t('sso:access.drawer_manage_user_access.body.subtitle')}
        </h2>

        {userApplications.map((userApp) => (
          <CardApplicationAccountUser
            key={userApp.application.applicationKey}
            ref={(ref) => {
              if (ref) {
                formRefs.current[userApp.application.applicationKey] = ref
              }
            }}
            userApplication={userApp}
          />
        ))}
      </Drawer.Body>

      <Drawer.Footer className="flex w-full justify-end">
        <Button.Root
          variant="secondary"
          color="brand"
          onClick={handleCloseDrawer}
          type="button"
        >
          {t('sso:access.drawer_manage_user_access.footer.button_close.label')}
        </Button.Root>
      </Drawer.Footer>
    </Drawer.Root>
  )
}
